import MainPage from "./MainPage";

const page = MainPage;
export default page;
